import { IonIcon, useIonToast } from '@ionic/react';
import { callOutline, logOutOutline } from 'ionicons/icons';
import moment from 'moment';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { UpdateUserFunc } from '../../hooks/WPHooks';
import { Auth, useAuth } from '../../services/AuthService';
import { PhotoParameters } from './parameters/PhotoParameters';
import PhoneInput from 'react-phone-number-input';
import { User, UserUpdate } from '../../model/models';
import { Link } from 'react-router-dom';
import { ModelsService } from '../../services/ModelsService';
import { useParameters } from '../../hooks/ParametersHooks';
import { useWizard } from '../../hooks/WizardHooks';
import { TagParameters } from './parameters/TagParameters';

export const ModalProfileEdit: React.FC<{
  houseName: string;
  user: User;
  update: UpdateUserFunc;
}> = ({ houseName, user, update }) => {
  const auth = useAuth();

  const intl = useIntl();

  const [present] = useIonToast();

  const { updateParameter, parameters } = useParameters(user, update);
  const { isSetLoading } = useWizard();

  const formatDate = (date: string | undefined) => {
    return date ? moment(date, 'YYYYMMDDHHZ').format('LL') : '';
  };

  const [disableSubmitButton, setDisableSubmitButton] = useState(false);

  const [phoneNb, setPhoneNb] = useState(user?.acf['mobilephone']);

  const typeGiaColors = ModelsService.userTypeGia(user);

  const [loading, setLoading] = useState(false);

  const handleSignOut = (e: any) => {
    e.preventDefault();
    setLoading(true);
    Auth.signOut(true).finally(() => {
      // setLoading(false);
    });
    return false;
  };

  function activateButtonUpdateUserPhoneAcf(phoneValue) {
    if (user) {
      setPhoneNb(phoneValue);
      var regexPhone =
        /^(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/;
      if (
        (phoneValue && regexPhone.test(phoneValue)) ||
        phoneValue === undefined
      ) {
        setDisableSubmitButton(false);
      } else {
        setDisableSubmitButton(true);
      }
    }
  }

  function updateUserPhoneAcf() {
    if (user) {
      setDisableSubmitButton(true);
      const data: UserUpdate = {
        acf: { mobilephone: phoneNb ? phoneNb : null },
      };
      update(data).then(() => {
        setDisableSubmitButton(false);
        // Add a notification
        present({
          color: 'primary',
          position: 'top',
          message: intl.formatMessage({
            id: 'Information saved successfully',
          }),
          duration: 1000,
        });
      });
    }
  }

  let changeEmail: string = 'mailto:support@ciup.help?subject=';
  changeEmail += intl.formatMessage({
    id: '[Residents Portal] Request to update my email address',
  });

  return (
    <div className="modal-profile-content md:bg-white md:rounded-3xl md:p-5">
      <div
        className={`${typeGiaColors.bg} relative flex flex-col justify-between pt-10 px-6 pb-20 md:rounded-3xl md:overflow-x-hidden `}
      >
        <div
          className={`hidden absolute top-5 right-5 bg-white items-center justify-center rounded-full w-12 h-12 ${typeGiaColors.color} md:flex`}
        >
          <svg
            width="24"
            height="36"
            viewBox="0 0 24 36"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_3661_11808)">
              <path d="M19.5232 31.075C18.5382 32.0809 17.3656 32.8794 16.0732 33.4244C14.7809 33.9694 13.3944 34.25 11.994 34.25C10.5936 34.25 9.20709 33.9694 7.91471 33.4244C6.62233 32.8794 5.44972 32.0809 4.46473 31.075C2.57379 29.1276 1.48872 26.5109 1.48872 23.8942V12.105C1.48872 9.48828 2.57379 6.87043 4.46473 4.9242C5.44965 3.91816 6.62223 3.1195 7.91462 2.57442C9.20701 2.02935 10.5935 1.7487 11.994 1.7487C13.3944 1.7487 14.7809 2.02935 16.0733 2.57442C17.3657 3.1195 18.5383 3.91816 19.5232 4.9242C21.4218 6.87264 22.5113 9.49049 22.5113 12.105C22.5113 14.8346 20.5076 16.3095 18.6232 16.3095C16.4695 16.3095 14.6508 14.5005 14.6508 12.3584C14.6623 11.6495 14.3952 10.9649 13.9083 10.4546C13.4213 9.94423 12.754 9.64968 12.0526 9.63543C10.501 9.63543 9.28459 10.8226 9.28459 12.3374V23.6673C9.28459 25.1832 10.501 26.3704 12.0526 26.3704C12.7543 26.3558 13.4217 26.0609 13.9087 25.5501C14.3957 25.0393 14.6625 24.3544 14.6508 23.6452C14.6508 21.5031 16.4695 19.693 18.6232 19.693C20.5076 19.693 22.5113 21.1657 22.5113 23.8975C22.5113 26.512 21.4218 29.1287 19.5232 31.0772V31.075ZM18.6232 18.6961C15.9341 18.6961 13.6621 20.9632 13.6621 23.6474C13.6621 24.6797 12.83 25.3735 12.0526 25.3735C11.1766 25.3735 10.2744 24.7362 10.2744 23.6696V12.3318C10.2744 11.2663 11.1788 10.629 12.0526 10.629C12.83 10.629 13.6621 11.3228 13.6621 12.3551C13.6621 15.0382 15.9341 17.3053 18.6232 17.3053C21.6759 17.3053 23.5 14.6609 23.5 12.105C23.5 9.22826 22.3076 6.35704 20.2273 4.22271C19.1503 3.12224 17.8681 2.24857 16.4547 1.65231C15.0414 1.05604 13.525 0.749023 11.9934 0.749023C10.4619 0.749023 8.94549 1.05604 7.53213 1.65231C6.11878 2.24857 4.83652 3.12224 3.75959 4.22271C1.68799 6.35483 0.5 9.22715 0.5 12.1039V23.8953C0.5 26.772 1.68799 29.6488 3.75959 31.7765C4.83659 32.8768 6.11888 33.7503 7.53222 34.3465C8.94557 34.9427 10.4619 35.2497 11.9934 35.2497C13.525 35.2497 15.0413 34.9427 16.4546 34.3465C17.868 33.7503 19.1503 32.8768 20.2273 31.7765C22.3076 29.6432 23.5 26.7698 23.5 23.8953C23.5 21.3383 21.6759 18.695 18.6232 18.695" />
              <path d="M18.5608 23.1424C18.4298 23.1424 18.3042 23.195 18.2116 23.2886C18.119 23.3822 18.067 23.5091 18.067 23.6414C18.0676 25.2714 17.4281 26.835 16.289 27.989C15.1499 29.143 13.6042 29.7931 11.9912 29.7966C9.04261 29.7966 5.88485 27.3779 5.88485 23.7764V12.2241C5.88485 8.61926 9.04261 6.19725 11.9912 6.19725C13.6047 6.20223 15.1503 6.8538 16.289 8.00897C17.4276 9.16415 18.0662 10.7286 18.0648 12.359C18.0583 12.4284 18.0662 12.4983 18.0881 12.5644C18.1099 12.6304 18.1451 12.6911 18.1915 12.7426C18.2379 12.7941 18.2944 12.8353 18.3574 12.8634C18.4204 12.8916 18.4886 12.9061 18.5575 12.9061C18.6264 12.9061 18.6946 12.8916 18.7576 12.8634C18.8206 12.8353 18.8771 12.7941 18.9235 12.7426C18.9699 12.6911 19.0051 12.6304 19.027 12.5644C19.0488 12.4983 19.0567 12.4284 19.0502 12.359C19.0521 10.935 18.6333 9.54271 17.8476 8.36054C17.0618 7.17836 15.9448 6.26006 14.6395 5.72319C13.3342 5.18632 11.9001 5.0553 10.5207 5.34692C9.14128 5.63854 7.87939 6.33952 6.89656 7.36013C5.63009 8.65973 4.91114 10.4046 4.89066 12.2285V23.7764C4.91181 25.5982 5.63078 27.3408 6.89656 28.6381C7.87991 29.6569 9.14149 30.3564 10.5201 30.6471C11.8988 30.9379 13.3319 30.8067 14.6364 30.2704C15.9409 29.7341 17.0576 28.8169 17.8438 27.6362C18.63 26.4554 19.05 25.0646 19.0502 23.6414C19.0502 23.5758 19.0374 23.5108 19.0125 23.4502C18.9876 23.3896 18.9512 23.3345 18.9052 23.2882C18.8592 23.2418 18.8047 23.2051 18.7446 23.1801C18.6846 23.1551 18.6203 23.1423 18.5553 23.1424" />
              <path d="M11.8894 31.9862C7.35533 31.9862 3.66981 28.2409 3.66981 23.6414V12.3347C3.66981 7.72858 7.35861 3.98105 11.8927 3.98105C16.4268 3.98105 20.2787 7.80713 20.2787 12.3347C20.2787 13.1999 19.6875 14.0762 18.5619 14.0762C17.4976 14.0641 16.81 13.3814 16.81 12.3347C16.81 9.43803 14.8151 7.41435 11.9573 7.41435C9.12801 7.41435 7.07393 9.4834 7.07393 12.3347V23.6414C7.07393 26.5271 9.08203 28.543 11.9573 28.543C14.8151 28.543 16.81 26.5271 16.81 23.6414C16.81 22.5959 17.4976 21.9132 18.5553 21.901C19.6875 21.901 20.2787 22.7762 20.2787 23.6414C20.2787 28.1624 16.4388 31.9818 11.8927 31.9818L11.8894 31.9862ZM18.5498 20.9019C16.9403 20.9218 15.8235 22.0471 15.8235 23.6414C15.8235 25.9749 14.2709 27.5428 11.9595 27.5428C9.66672 27.5428 8.06484 25.9395 8.06484 23.6414V12.3347C8.06484 10.0267 9.66672 8.41346 11.9595 8.41346C14.2654 8.419 15.8235 9.99015 15.8235 12.3347C15.8235 13.9302 16.9458 15.0577 18.5608 15.0754C20.3225 15.0754 21.2729 13.6635 21.2729 12.3347C21.2729 7.26498 16.9797 2.98193 11.8982 2.98193C6.81663 2.98193 2.68657 7.17757 2.68657 12.3347V23.6414C2.68657 28.7919 6.81882 32.9809 11.8982 32.9809C16.9775 32.9809 21.2729 28.7045 21.2729 23.6414C21.2729 21.8623 19.8758 20.9019 18.5553 20.9019" />
            </g>
            <defs>
              <clipPath id="clip0_3661_11808">
                <rect
                  width="23"
                  height="34.5"
                  fill="white"
                  transform="translate(0.5 0.75)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div
          className={`absolute w-1/2 h-1/2 -top-5 -left-2 ${typeGiaColors.svg} md:w-1/3 md:h-2/3 md:left-0 md:top-0`}
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 218 260"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.4">
              <path d="M-7.99998 -192C-132.821 -192 -234 -90.8206 -234 34C-234 158.821 -132.821 260 -7.99998 260C116.821 260 218 158.821 218 34C218 -90.8206 116.821 -192 -7.99998 -192ZM137.44 179.44C98.5882 218.292 46.9383 239.685 -7.99998 239.685C-62.9383 239.685 -114.588 218.292 -153.44 179.44C-192.292 140.588 -213.685 88.9383 -213.685 34C-213.685 -20.9383 -192.292 -72.5882 -153.44 -111.44C-114.588 -150.292 -62.9383 -171.685 -7.99998 -171.685C46.9383 -171.685 98.5882 -150.292 137.44 -111.44C176.292 -72.5882 197.685 -20.9383 197.685 34C197.685 88.9383 176.292 140.588 137.44 179.44Z" />
              <path d="M-7.99997 -147.562C-108.278 -147.562 -189.562 -66.2782 -189.562 33.9998C-189.562 134.278 -108.278 215.562 -7.99997 215.562C92.278 215.562 173.562 134.278 173.562 33.9998C173.562 -66.2782 92.278 -147.562 -7.99997 -147.562ZM106.016 148.016C75.5565 178.475 35.067 195.247 -7.99997 195.247C-51.0669 195.247 -91.5692 178.475 -122.016 148.016C-152.475 117.556 -169.247 77.0668 -169.247 33.9998C-169.247 -9.06717 -152.475 -49.5694 -122.016 -80.0159C-91.5565 -110.475 -51.0669 -127.247 -7.99997 -127.247C35.067 -127.247 75.5692 -110.475 106.016 -80.0159C136.475 -49.5567 153.247 -9.06717 153.247 33.9998C153.247 77.0668 136.475 117.569 106.016 148.016Z" />
              <path d="M-8 -103.124C-83.7354 -103.124 -145.124 -41.7353 -145.124 34.0001C-145.124 109.735 -83.7354 171.124 -8 171.124C67.7354 171.124 129.124 109.735 129.124 34.0001C129.124 -41.7353 67.7354 -103.124 -8 -103.124ZM-8 150.809C-72.41 150.809 -124.809 98.4101 -124.809 34.0001C-124.809 -30.4099 -72.41 -82.8089 -8 -82.8089C56.41 -82.8089 108.809 -30.4099 108.809 34.0001C108.809 98.4101 56.41 150.809 -8 150.809Z" />
              <path d="M-8.00004 -58.6855C-59.1928 -58.6855 -100.685 -17.193 -100.685 33.9998C-100.685 85.1926 -59.1928 126.685 -8.00004 126.685C43.1928 126.685 84.6853 85.1926 84.6853 33.9998C84.6853 -17.193 43.1928 -58.6855 -8.00004 -58.6855ZM-8.00004 106.371C-47.9055 106.371 -80.3708 73.9053 -80.3708 33.9998C-80.3708 -5.90566 -47.9055 -38.3709 -8.00004 -38.3709C31.9055 -38.3709 64.3707 -5.90566 64.3707 33.9998C64.3707 73.9053 31.9055 106.371 -8.00004 106.371Z" />
              <path d="M-8 -14.2471C-34.6502 -14.2471 -56.2472 7.3499 -56.2472 34.0001C-56.2472 60.6503 -34.6502 82.2473 -8 82.2473C18.6502 82.2473 40.2472 60.6503 40.2472 34.0001C40.2472 7.3499 18.6502 -14.2471 -8 -14.2471ZM-8 61.9327C-23.401 61.9327 -35.9326 49.4011 -35.9326 34.0001C-35.9326 18.5991 -23.401 6.06754 -8 6.06754C7.40101 6.06754 19.9326 18.5991 19.9326 34.0001C19.9326 49.4011 7.40101 61.9327 -8 61.9327Z" />
            </g>
          </svg>
        </div>
        <div className="relative flex flex-col w-full justify-between items-center p-4 pl-6">
          <div className="relative rounded-full flex justify-center items-center border-white border-opacity-20 border h-36 w-36">
            <PhotoParameters
              user={user}
              updateParameter={updateParameter}
              parameters={parameters}
              isSetLoading={isSetLoading}
            />
          </div>
        </div>
        <h4 className="relative flex flex-row text-lg font-bold text-white leading-5 mb-2 justify-center items-center md:text-xl">
          <span className="uppercase mr-1">
            {user?.last_name || 'Not loaded yet'}
          </span>
          {user?.first_name || 'Not loaded yet'}
        </h4>
        <div className="flex justify-center mb-8">
          <p
            className={`bg-white font-medium rounded-md px-1.5 py-0.5 ${typeGiaColors.color}`}
          >
            {user?.acf?.user_honorary_title ? (
              user?.acf?.user_honorary_title
            ) : (
              <FormattedMessage id={user?.acf?.user_gia_type || 'default'} />
            )}
          </p>
        </div>
        <p className="relative mt-1 text-xs text-white font-bold md:text-sm">
          <FormattedMessage id="House" />
        </p>
        <p className="relative text-sm text-white font-medium md:text-base">
          {houseName}
        </p>
        <p className="relative mt-3 text-xs text-white font-bold md:text-sm">
          <FormattedMessage id="Period of stay" />
        </p>
        <p className="relative text-sm text-white font-medium md:text-base">
          {formatDate(user?.acf.staystart) || 'Not loaded yet'} -{' '}
          {formatDate(user?.acf.stayend)}
        </p>
      </div>
      <div className="bg-white relative rounded-t-3xl text-left text-sm ion-text-wrap profile-content -mt-10 px-5 pt-10 md:-mt-0 md:text-base">
        <ul className="pb-6">
          <li className="relative flex flex-row justify-between items-center text-left bg-white border border-primary border-opacity-40 rounded-xl my-3">
            <div className="w-full">
              <label
                htmlFor="name"
                className="block absolute text-sm font-medium text-gray-900 left-6 top-5 "
              >
                <FormattedMessage id="Phone number" />
              </label>
              <PhoneInput
                placeholder={intl.formatMessage({ id: 'Enter phone number' })}
                defaultCountry="FR"
                value={user?.acf['mobilephone'] || ''}
                onChange={activateButtonUpdateUserPhoneAcf}
              />
            </div>
            <div className="flex absolute w-10 h-10 right-6 justify-center items-center border border-transparent rounded-full text-white bg-primary">
              <IonIcon icon={callOutline} />
            </div>
          </li>
          <li className="col-span-1 flex flex-col text-left bg-white border border-primary border-opacity-40 rounded-xl my-3">
            <a href={changeEmail}>
              <div className="flex-1 flex flex-row justify-between items-center p-6 py-5">
                <div>
                  <h3 className=" text-black font-medium text-sm">
                    <FormattedMessage id="Mail" />
                  </h3>
                  <p className="italic text-black text-xs text-opacity-50">
                    {user?.email || 'Not loaded yet'}
                  </p>
                </div>
                <div className="flex w-10 h-10 inset-7 justify-center items-center border border-transparent rounded-full text-white bg-primary">
                  <IonIcon icon={logOutOutline} />
                </div>
              </div>
            </a>
          </li>
          <li className="col-span-1 flex flex-col text-left bg-white border border-primary border-opacity-40 rounded-xl my-3">
            <a
              href={auth.authConfig.server_host}
              rel="noreferrer"
              target="_blank"
            >
              <div className="flex-1 flex flex-row justify-between items-center p-6 py-5">
                <div>
                  <h3 className=" text-black font-medium text-sm">
                    <FormattedMessage id="Password" />
                  </h3>
                  <p className="italic text-black text-xs text-opacity-50">
                    ••••••
                  </p>
                </div>
                <div className="flex w-10 h-10 inset-7 justify-center items-center border border-transparent rounded-full text-white bg-primary">
                  <IonIcon icon={logOutOutline} />
                </div>
              </div>
            </a>
          </li>
          <li>
            <TagParameters
              user={user}
              updateParameter={updateParameter}
              parameters={parameters}
              isSetLoading={() => {}}
              onProfilEditPage={true}
            />
          </li>
          <li className="col-span-1 flex flex-col text-left bg-white rounded-xl my-3">
            <button
              type="button"
              disabled={disableSubmitButton}
              className="inline-flex items-center justify-center px-6 py-4 mt-3 mb-3 w-50 border border-transparent shadow-sm font-bold rounded-3xl text-sm text-white text-center bg-primary hover:bg-secondary focus:outline-none disabled:bg-lightGrey"
              onClick={(event: React.MouseEvent<HTMLElement>) => {
                updateUserPhoneAcf();
              }}
            >
              <p>
                <FormattedMessage id="Edit those informations" />
              </p>
            </button>
          </li>
          <li className="hidden md:block">
            <a
              href="#logout"
              onClick={handleSignOut}
              className={` font-bold text-sm flex justify-center items-center ${
                loading === true ? 'text-lightGrey' : 'text-primary'
              }`}
            >
              <FormattedMessage id="Logout" />
              <IonIcon icon={logOutOutline} className="text-xl ml-2" />
            </a>
          </li>
        </ul>
        <ul className="hidden md:flex w-full flex-wrap justify-center px-6 mt-4">
          <li>
            <Link
              to="/pages/faq"
              className="text-black opacity-40 text-xs font-medium"
            >
              <FormattedMessage id="FAQ" />
            </Link>
          </li>
          <li>
            <Link
              to="/pages/policy"
              className="text-black opacity-40 text-xs font-medium ml-2"
            >
              <FormattedMessage id="Privacy Policy" />
            </Link>
          </li>
          <li>
            <Link
              to="/pages/legal"
              className="text-black opacity-40 text-xs font-medium ml-2"
            >
              <FormattedMessage id="Legal Notice" />
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};
